import { getBookingTotals as getSharedBookingTotals } from '@repo/lib';
import getPriceLabel from '@dashboard/services/translation/getPriceLabel';

export { getAddOns, getTicketRow, groupTickets } from '@repo/lib';

export const moneyFor = currency => amount => getPriceLabel({ amount, currency });

/** The booking's totals, in English, from the shared order summary. */
export const getBookingTotals = payment =>
  getSharedBookingTotals(payment, { money: moneyFor(payment.currency) });
